export enum ENUM__image_asset_category {
  ANY = 'ANY', //is not valid for saving to db

  IMAGE = 'IMAGE',
  MASK = 'MASK',

  COLOR_MAP = 'COLOR_MAP',

  //
  LINE__CANNY = 'LINE__CANNY',
  LINE__LINEART = 'LINE__LINEART',
  LINE__MLSD = 'LINE__MLSD',
  LINE__SOFT_EDGE = 'LINE__SOFT_EDGE',
  LINE__SCRIBBLE = 'LINE__SCRIBBLE',

  //
  DEPTH = 'DEPTH',
  DEPTH__ZOE = 'DEPTH__ZOE',
  POSE = 'POSE',

  SEGMENTATION = 'SEGMENTATION',
}

export namespace ENUM_UTILS__image_asset_category {
  export function values_without_any(): ENUM__image_asset_category[] {
    let out = Object.values(ENUM__image_asset_category);

    let invalid_values = [ENUM__image_asset_category.ANY];

    out = out.filter(item => !invalid_values.includes(item));

    return out;
  }

  export function categories_control_net_with_empty_images() {
    return [
      ENUM__image_asset_category.LINE__CANNY,
      ENUM__image_asset_category.LINE__LINEART,
      ENUM__image_asset_category.LINE__MLSD,
      ENUM__image_asset_category.LINE__SOFT_EDGE,
      ENUM__image_asset_category.LINE__SCRIBBLE,
      //
      ENUM__image_asset_category.DEPTH,
      ENUM__image_asset_category.DEPTH__ZOE,
    ];
  }
}
